/*
 * @Description: Description
 * @Author: Kun Yang
 * @Date: 2022-06-09 14:52:26
 * @LastEditors: Kun Yang
 * @LastEditTime: 2022-06-10 09:30:46
 */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import initLoading from '@/assets/init_loading.gif';
import loadingStyle from './initLoading.module.scss';

export default function InitLoading(props) {
  const { t } = useTranslation();
  const { style } = props;
  const { width, height } = style;
  return (
    <div className={loadingStyle.loading}>
      <div className={loadingStyle.imgWrap} style={{ width: `${width}rem`, height: `${height}rem` }}>
        <img style={{ width: '100%', maxWidth: '140px' }} src={initLoading} alt="" />
      </div>
      <p>{t('initLoading.initLoadingT1')}</p>
      <p>{t('initLoading.initLoadingT2')}</p>
    </div>
  );
}

InitLoading.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object]),
};

InitLoading.defaultProps = {
  style: {
    width: '', // 宽度
    height: '', // 高度
  },
};
